  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.side-tab .tab-btn');
    const tabContents = document.querySelectorAll('.side-tab .tab-content');

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        // Remove active class from all buttons
        tabButtons.forEach((b) => b.classList.remove('active'));
        // Hide all tab contents
        tabContents.forEach((c) => (c.style.display = 'none'));

        // Activate clicked tab
        this.classList.add('active');
        const tab = document.getElementById('tab-' + this.dataset.tab);
        if (tab) tab.style.display = 'block';
      });
    });

    // Show first tab by default
    tabContents.forEach((c, i) => (c.style.display = i === 0 ? 'block' : 'none'));
  });